module.exports = {"principleLabel":"Principal"}